module.exports = __webpack_public_path__ + "static/media/login-background.e1558ea2.png";